<template>

    <Head title="Detail Data Kunjungan" />
    <div class="card card-outline card-primary">
        <div class="card-header">
            <h1 class="card-title">DETAIL DATA KUNJUNGAN | {{ this.kunjungan.user.name }}</h1>
            <div class="card-tools">
                <Link class="btn btn-tool" href="#" @click="back">
                <i class="fas fa-times"></i>
                </Link>
            </div>
        </div>
        <div class="card-body">
            <form>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm">
                                <input-text label="Rekening" v-model="form.rek" readonly />
                            </div>
                            <div class="col-sm">
                                <input-text label="Macet" v-model="form.bln_tung" readonly />
                            </div>
                        </div>
                        <input-text label="Nama" v-model="form.nama" readonly />
                        <text-area label="Alamat" v-model="form.alamat" readonly />
                        <div class="row">
                            <div class="col-sm">
                                <input-text label="Titipan" v-model="form.titipan" readonly />
                            </div>
                            <div class="col-sm">
                                <input-text label="Tunggakan" v-model="form.tunggakan" readonly />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm">
                                <input-text label="Masa Angsuran" v-model="form.masa_angsuran" readonly />
                            </div>
                            <div class="col-sm">
                                <input-text label="Angsuran" v-model="form.angsuran" readonly />
                            </div>
                        </div>
                        <text-area label="Jaminan" v-model="form.jaminan" readonly />
                        <div class="row">
                            <div class="col-sm">
                                <datepicker label="Tanggal Kunjungan" v-model="form.tgl_kunj"
                                    class="fas fa-calendar-alt" disabled />
                            </div>
                            <div class="col-sm">
                                <datepicker label="Tanggal Janji" v-model="form.tgl_janji" class="fas fa-calendar-alt"
                                    disabled />
                            </div>
                        </div>
                        <text-area label="Keterangan" v-model="form.keterangan" readonly />
                    </div>
                    <div class="col-sm-6">
                        <div v-if="this.form.image">
                            <div v-for="img in this.form.image.split('|')" class="mb-3 text-center">
                                <img :src="img" class="img-fluid"
                                    style="width: 80%; padding:.25rem; background-color: #fff; border: 1px solid #dee2e6;border-radius: .25rem; box-shadow: 0 1px 2px rgba(0,0,0,.075);">
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Layout from "@/Layouts/Master"
import InputText from '@/Forms/InputText'
import InputFile from '@/Forms/InputFile'
import TextArea from '@/Forms/TextArea'
import InputSelect2 from '@/Forms/InputSelect2'
import Datepicker from '@/Forms/Datepicker'
import { Head, Link } from '@inertiajs/vue3'

export default {
    layout: Layout,
    components: {
        Head,
        Link,
        InputText,
        InputFile,
        TextArea,
        InputSelect2,
        Datepicker,
    },
    props: {
        kunjungan: Object,
        isToday: Boolean,
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                rek: this.kunjungan.rek,
                nama: this.kunjungan.tagihan.nama,
                alamat: this.kunjungan.tagihan.alamat,
                bln_tung: this.kunjungan.tagihan.bln_tung,
                titipan: this.kunjungan.tagihan.titipan,
                tunggakan: this.kunjungan.tagihan.tunggakan,
                masa_angsuran: this.kunjungan.tagihan.masa_angsuran,
                angsuran: this.kunjungan.tagihan.angsuran,
                keterangan: this.kunjungan.keterangan,
                tgl_kunj: this.kunjungan.created_at,
                tgl_janji: this.kunjungan.tgl_janji,
                jaminan: this.kunjungan.tagihan.jaminan,
                image: this.kunjungan.picture,
            }),
            koordinat: this.kunjungan.lat + ', ' + this.kunjungan.lng,
        }
    },
    methods: {
        back() {
            window.history.back();
        },
    },
}
</script>
